import { render, staticRenderFns } from "./ReplaceDiscussionDocument.vue?vue&type=template&id=78f4bcda&scoped=true"
import script from "./ReplaceDiscussionDocument.vue?vue&type=script&lang=js"
export * from "./ReplaceDiscussionDocument.vue?vue&type=script&lang=js"
import style0 from "./ReplaceDiscussionDocument.vue?vue&type=style&index=0&id=78f4bcda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4bcda",
  null
  
)

export default component.exports